
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outdoor-campaign",
      function () {
        return require("private-next-pages/outdoor-campaign/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outdoor-campaign"])
      });
    }
  